<script setup>
import { AbcHeading } from "@ordbogen-npm/abc-dsk";
import { computed, toRefs } from "vue";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import { QuestionTypeEnum } from "@/common/composables/use-vocab-quiz";
import { createQuestionText } from "@/common/vocabulary-trainer-helpers";
import { i18n } from "@/i18n";
import { useSettingsStore } from "@/stores";

const props = defineProps({
  question: {
    type: Object,
    required: true
  },
  questionType: {
    type: String,
    required: true,
    validator: (value) => Object.values(QuestionTypeEnum).includes(value)
  },
  promptId: {
    type: String,
    required: true
  },
  noSkipping: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["skip"]);

const settingsStore = useSettingsStore();
const { t } = i18n.global;

const { question, questionType } = toRefs(props);

const prompt = computed(() =>
  createQuestionText(questionType.value, question.value, settingsStore.activeLanguageGroup)
);
</script>

<template>
  <div class="quiz-prompt">
    <div
      class="col-12 col-lg-6 d-flex align-items-center justify-content-center justify-content-lg-start"
    >
      <AbcHeading :id="promptId" tag="h1" size="xl" class="text-center text-lg-left" lang="en">
        {{ prompt }}
      </AbcHeading>
    </div>
    <div class="col-lg-6 d-none d-lg-flex flex-column align-items-between quiz-prompt__right">
      <div class="d-flex justify-content-end">
        <TgButton
          v-if="!noSkipping"
          variant="text"
          color="secondary"
          class="mr-1"
          @click="emit('skip')"
        >
          {{ t("vocab.games.skip") }}
        </TgButton>
      </div>
      <div class="d-flex justify-content-end align-items-end">
        <slot name="prompt-image" />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.quiz-prompt {
  padding: 50px 0;

  #media-breakpoint-up(lg, {
    padding: 0;
  });
}

.quiz-prompt__right {
  padding-top: 15px;

  #media-breakpoint-up(xxl, {
    padding-top: 30px;
  });
}
</style>
